// Kullanıcıya özel tek obje LS yardımcıları

export interface UserStateEnvelope<T> {
  v: number;
  rev: number;
  updatedAt: number;
  state: T;
}

export interface PersistOptions {
  userId: string;
  version: number;
}

const NS = "harmony:v1";

function makeKey(userId: string): string {
  return `${NS}:user:user-${userId}`;
}

export type HarmonyUserState = {
  llm?: {
    selectedModelName: string | null;
    selectedProvider: string;
  };
  search?: {
    history: string[];
    updatedAt?: number;
  };
};

export function readUserState(
  opts: PersistOptions
): UserStateEnvelope<HarmonyUserState> | null {
  try {
    const raw = localStorage.getItem(makeKey(opts.userId));
    if (!raw) return null;
    const env = JSON.parse(raw) as UserStateEnvelope<HarmonyUserState>;
    return env;
  } catch {
    return null;
  }
}

export function writeUserState(
  opts: PersistOptions,
  partial: Partial<HarmonyUserState>
): void {
  const key = makeKey(opts.userId);
  const existing = readUserState(opts);
  const nextState: HarmonyUserState = {
    ...(existing?.state || {}),
    ...partial,
  };
  const envelope: UserStateEnvelope<HarmonyUserState> = {
    v: opts.version,
    rev: (existing?.rev || 0) + 1,
    updatedAt: Date.now(),
    state: nextState,
  };
  localStorage.setItem(key, JSON.stringify(envelope));
}

export function clearUserState(userId: string): void {
  try {
    localStorage.removeItem(makeKey(userId));
  } catch {}
}
